<template>
  <v-select
    v-model="selected"
    :items="items"
    :label="label"
    item-text="description"
    item-value="id"
    :hide-details="!v.$error || !v.$anyError"
    :error-messages="errors"
    dense
    outlined
    :disabled="disabled"
  >
    <template v-if="translate" v-slot:item="{ item }">
      {{ $t(item.description) }}
    </template>
    <template v-if="translate" v-slot:selection="{ item }">
      {{ $t(item.description) }}
    </template>
    <template v-if="disabled" v-slot:append>
      <span></span>
    </template>
  </v-select>
</template>

<script>
export default {
  props: [
    'value',
    'v',
    'errors',
    'label',
    'items',
    'disabled',
    'translate',
  ],

  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/SelectComponent.vue